import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing } from "services/activity/action";
import { $done } from "services/activity/action";

export const MODULE = "Client";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $show = ActionCreator.Async(MODULE, "Show", (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/user/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});
